import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class LeftNav extends Vue {

    get applications() {
        return this.$store.getters.userApplications;
    }

    updateParentTitle(applicationName: string) {
        this.$store.dispatch('setApplicationName', applicationName);
    }

    destroyed() {
        console.log('left nav destroyed');
    }

    mounted() {
    }
}



// WEBPACK FOOTER //
// ./ClientApp/src/portalhome/leftnav/leftnav.ts